import * as React from 'react';
import cx from 'clsx';

import * as styles from './OnboadringLayout.css';

type TProps = {
  children: React.ReactNode;
  isMobile?: boolean;
};

export const OnboardingLayout: React.FC<TProps> = ({ children, isMobile }) => {
  return <div className={cx(styles['container'], isMobile && styles['container_mobile'])}>{children}</div>;
};
